import { render, staticRenderFns } from "./AdditionalServiceListSection.vue?vue&type=template&id=ab8c4b34"
import script from "./AdditionalServiceListSection.vue?vue&type=script&lang=js"
export * from "./AdditionalServiceListSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports